import { Button, Card, Container, Modal } from 'react-bootstrap';
import { Footer } from '../../components/Footer/Footer';
import { useFirebase } from '../../../contexts/FirebaseContext';
import { useEffect, useState } from 'react';
import { FullscreenLoader } from '../../components/FullscreenLoader/FullscreenLoader';
import { useHistory, useParams } from 'react-router-dom';
import { formatSecondsTimestamp } from '../../utils/utils';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faCalendarCheck, faCoins, faHourglassHalf, faPaperPlane } from '@fortawesome/free-solid-svg-icons';
import { useQuery } from '../../../hooks/useQuery';
import { Copyable } from '../../components/Copyable/Copyable';
import { useTranslation } from 'react-i18next';
import { Title } from '../../components/Title/Title';
import { useGaming } from '../../../contexts/GamingContext';
import { AppShell } from '../../components/AppShell/AppShell';

const GiftDetailsComponent = () => {
  const { getCheckoutDetails } = useFirebase();
  const { track } = useGaming();
  const { t } = useTranslation();

  const { id } = useParams<{ id: string }>();
  const { sid } = useQuery();
  const [loading, setLoading] = useState(false);
  const [details, setDetails] = useState<any>(null);
  const [successModalOpen, setSuccessModalOpen] = useState(false);
  const history = useHistory();

  useEffect(() => {
    if (!id) history.replace('/gift');
    setLoading(true);
    getCheckoutDetails(id)
      .then((res) => {
        if (!res.coupons) history.replace('/gift');
        else setDetails(res);
      })
      .catch(console.error)
      .finally(() => {
        setLoading(false);
      });
  }, [id]);

  useEffect(() => {
    if (sid) {
      setSuccessModalOpen(true);
      track('GIFT_SUBSCRIPTION', { sid });
    }
  }, []);

  if (loading || !details) return <FullscreenLoader />;

  return (
    <AppShell>
      <Title>{t('giftDetails.labels.dettaglioRegalo')}</Title>

      <Container>
        <div className={'d-flex align-items-center'}>
          <Button onClick={() => history.push('/gift')} className={'tootor-button tootor-button--basic mr-2'}>
            <FontAwesomeIcon icon={faArrowLeft} />
          </Button>
          <h1 className={'text-page-title mb-0'}>{t('giftDetails.labels.dettaglioRegalo')}</h1>
        </div>

        <Card className={'surface-card mt-4'}>
          <Card.Body>
            <Card.Title>{t('labels.transazione')}</Card.Title>
            <div>
              <FontAwesomeIcon icon={faCoins} fixedWidth={true} className={'mr-2'} />
              {t('giftDetails.labels.idtransazione')} <Copyable text={id} />
            </div>
            <div>
              <FontAwesomeIcon icon={faCalendarCheck} fixedWidth={true} className={'mr-2'} />
              {t('giftDetails.labels.effettuataIl')} {formatSecondsTimestamp(details.ts._seconds, 'dd/MM/y HH:mm')}
            </div>
            {!!details.coupons?.[0]?.expires && (
              <div>
                <FontAwesomeIcon icon={faHourglassHalf} fixedWidth={true} className={'mr-2'} />
                {t('giftDetails.labels.scadenzaCodici')} {formatSecondsTimestamp(details.coupons?.[0]?.expires, 'dd/MM/y')}
              </div>
            )}
            <details className={'mt-2'}>
              <summary>
                <span className={'text-muted'}>{t('giftDetails.labels.dettagliTecnici')}</span>
              </summary>
              <div>{t('giftDetails.labels.inCasoContatto')}</div>
              <div>
                {t('giftDetails.labels.idsessione')} <Copyable text={details.sessionId} />
              </div>
              <div>
                {t('giftDetails.labels.idfattura')} <Copyable text={details.invoiceId} />
              </div>
              <div>
                {t('giftDetails.labels.idPagamento')} <Copyable text={details.paymentIntent} />
              </div>
            </details>
          </Card.Body>
        </Card>

        <Card className={'surface-card mt-3'}>
          <Card.Body>
            <Card.Title>{t('giftDetails.labels.couponGenerati')}</Card.Title>
            {details.coupons.map((coupon, i, arr) => (
              <div key={i.toString()} className={i == arr.length - 1 ? '' : 'mb-2'}>
                <div>
                  <strong>
                    <Copyable text={coupon.promoCode} />
                  </strong>{' '}
                  {coupon.productName}
                </div>
                <div className={'text-muted'}>
                  <FontAwesomeIcon icon={faPaperPlane} /> {coupon.name} | {coupon.email}
                </div>
              </div>
            ))}
          </Card.Body>
        </Card>
      </Container>

      {/*<pre>{JSON.stringify(details, null, 2)}</pre>*/}

      <Footer />

      <Modal className={'tootor-modal'} centered show={successModalOpen} onHide={() => setSuccessModalOpen(false)} backdrop={'static'} keyboard={false}>
        <Modal.Header closeButton>
          <Modal.Title className={'text-success'}>{t('giftDetails.labels.acquistoEffettuato')}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className={'mb-2'}>{t('giftDetails.labels.acquistoEffettuatoDescrizione')}</div>
          <div>{t('giftDetails.labels.acquistoRiepilogo')}</div>
        </Modal.Body>
        <Modal.Footer>
          <Button className={'tootor-button tootor-button--basic'} onClick={() => setSuccessModalOpen(false)}>
            {t('labels.chiudi')}
          </Button>
        </Modal.Footer>
      </Modal>
    </AppShell>
  );
};

export default GiftDetailsComponent;
